// extracted by css-extract-rspack-plugin
export default {"SharedMarkdownContent":"DirectoryRichtextContent-module__SharedMarkdownContent__aH1R11y"};